module.exports = __webpack_public_path__ + "img/szb.a355f05e.jpg";